import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const RemainingSessionsFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.sessions.filters.remaining_sessions);
  const selectedOption = useSelector((state) => state.sessions.selectedFilters.remaining_sessions);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOption}
      includeFilter={false}
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      onSelectChange={(data) =>
        dispatch(actionCreators.updateFilters({ remaining_sessions: data }))
      }
    />
  );
};

export default RemainingSessionsFilter;
